/**
 * Словарь строк на русском языке (эталонный).
 */
export const ru = {
  common: {
    brandName: 'QPRICE',
    save: 'Сохранить',
    saved: 'Сохранено',
    saving: 'Сохранение...',
    saveChanges: 'Сохранить изменения',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    close: 'Закрыть',
    back: 'Назад',
    next: 'Далее',
    all: 'Все',
    clear: 'Очистить',
    retry: 'Повторить',
    confirm: 'Подтвердить',
    create: 'Создать',
    add: 'Добавить',
    success: 'Успешно',
    error: 'Ошибка',
    notFound: 'Не найдено',
    loading: 'Загрузка...',
    search: 'Поиск',
    searchPlaceholder: 'Поиск по позициям и акциям',
    themeToggle: 'Сменить тему',
    themeDark: 'Тёмная тема',
    themeLight: 'Светлая тема',
    themeSwitchToDark: 'Включить тёмную тему',
    themeSwitchToLight: 'Включить светлую тему',
    support: 'Поддержка',
    supportPhone: '+7 777 246 84 83',
    supportPhoneLabel: 'Позвонить в поддержку партнёров',
    day: 'день',
    daysFew: 'дня',
    daysMany: 'дней',
    today: 'сегодня',
    tomorrow: 'завтра',
    yesterday: 'вчера',
    daysAgo: 'дней назад',
    tenge: '₸',
  },

  landing: {
    login: 'Войти',
    becomePartner: 'Стать партнёром',
    support: 'Поддержка',
    eyebrow: 'Партнёрская платформа для любого бизнеса с клиентами',
    heroTitleStrike: 'Свободные часы',
    heroTitleAccent: 'превращаем в клиентов.',
    heroSub: 'QPrice — прямой канал продаж для кафе, салонов, фитнеса, автосервисов, магазинов и любого локального бизнеса. Ставите скидку на пустой слот, на залежавшийся товар, на утренний час — и клиенты в радиусе 3 км видят её в приложении и приходят к вам сегодня, а не «когда-нибудь».',
    howItWorks: 'Посмотреть, как работает',
    heroMeta: 'Подключение за 3 минуты · первый месяц бесплатно',

    showcaseLabel: 'Живая витрина ваших скидок',
    showcaseTitle: 'Одна кнопка — и ваше предложение уже в кармане у клиента рядом.',
    showcaseDesc: 'В отличие от купонаторов и спам-рассылок, QPrice показывает только то, что действует прямо сейчас и рядом. Клиенты открывают приложение, чтобы решить: «куда пойти прямо сейчас».',

    statsUsers: 'активных пользователей приложения',
    statsVenues: 'партнёров из разных сфер уже работают с QPrice',
    statsSpeed: 'от регистрации до первой активной скидки',
    statsCommission: 'комиссии с чека — платите только подписку',

    cardHaircut: 'Женская стрижка',
    cardHaircutMeta: 'будни · 11:00 — 15:00',
    cardFitness: 'Тренировка с тренером',
    cardFitnessMeta: 'свободный слот сегодня',
    cardCoffee: 'Капучино с сиропом',
    cardCoffeeMeta: 'happy hour · до 19:00',

    featuresTitle: 'Почему партнёры остаются',
    featuresSubtitle: 'Это инструмент, которым владелец управляет загрузкой зала сам, в реальном времени — как ручкой громкости.',

    feat1Title: 'Прямой канал',
    feat1Desc: 'QPrice не берёт комиссию с чека. Вся выручка ваша — мы зарабатываем на подписке, а не на ваших оборотах.',

    feat2Title: 'Гибкость',
    feat2Desc: 'Скидка на час, на услугу, на категорию. Выбираете точечно: пятница 18:00 — 20:00, только стрижки, только новым клиентам.',

    feat3Title: 'Скорость',
    feat3Desc: 'Публикация — 3 секунды. Активность и деактивация в один тап.',

    feat4Title: 'Аналитика и меню',
    feat4Desc: 'Просмотры, переходы и возвраты по каждой акции. Загружайте меню, блюдо дня, сториз — без отдельных сервисов.',

    howTitle: 'Как это работает',
    howSubtitle: 'Три шага от пустого слота до довольного клиента. Никакой интеграции с кассой, не нужны разработчики.',

    step1Number: '01',
    step1Title: 'Регистрируете бизнес',
    step1Desc: 'Номер телефона, код в WhatsApp, название, адрес и фото. Три минуты — и ваш профиль живёт в приложении.',

    step2Number: '02',
    step2Title: 'Создаёте скидку в один клик',
    step2Desc: 'Выбираете услугу или товар, ставите процент, задаёте дни и часы — даже на один вечер. Хотите убрать через 10 минут? Уберёте.',

    step3Number: '03',
    step3Title: 'Клиенты приходят и платят полную маржу',
    step3Desc: 'Приложение показывает скидку людям рядом. Они приходят к вам, покупают ещё, возвращаются снова.',

    quoteText: 'Поставили скидку 30% на маникюр в будни утром — и впервые за полгода забили пустые слоты с 9 до 13. QPrice дал нам ручку, которой раньше не было.',
    quoteAuthor: 'Диана М.',
    quoteRole: 'владелица, салон красоты в Астане',

    ctaTitle: 'Попробуйте одну скидку. Посмотрите, кто придёт.',
    ctaSub: 'Регистрация бесплатная, первый месяц — без ограничений и без оплаты. Если не зайдёт — просто уйдёте. Если зайдёт — управляйте потоком клиентов по-новому.',
    ctaButton: 'Зарегистрировать заведение',

    footerPartners: 'Оферта для партнёров',
    footerClients: 'Соглашение для клиентов',
    footerPrivacy: 'Конфиденциальность',
    footerUgc: 'Правила публикации',
    footerSupport: 'Поддержка',
    footerCities: 'Алматы, Астана и ещё 12 городов',
    footerCopyright: '© 2026 QPrice.',
  },

  auth: {
    choiceEyebrow: 'Кабинет партнёра',
    choiceTitle: 'Ваше заведение в QPrice',
    choiceSubtitle: 'Меню, цены и акции вы ведёте сами — гости видят изменения сразу.',
    choiceNewVenueTitle: 'Новое заведение',
    choiceNewVenueSub: 'Подтвердите номер и заполните данные заведения — это займёт пару минут.',
    choiceNewVenueAction: 'Зарегистрироваться',
    choiceExistingVenueTitle: 'Уже есть кабинет',
    choiceExistingVenueSub: 'Войти по номеру телефона',
    choiceLoginButton: 'Войти по номеру',
    choiceRegisterButton: 'Зарегистрировать заведение',
    choiceHintLogin: 'Если кабинет уже заведён — войдите по номеру телефона.',
    choiceHintRegister: 'Новое заведение: подтвердите номер и заполните данные заведения.',

    loginTitle: 'Вход в кабинет партнёра',
    loginSubtitle: 'Введите номер, мы пришлём код в WhatsApp.',
    registerTitle: 'Регистрация заведения',
    registerSubtitle: 'Подтвердим номер, потом попросим данные заведения — это займёт пару минут.',
    confirmTitle: 'Подтверждение',
    enterCode: 'Введите код из WhatsApp',
    codeNoticeRegistration: 'После кода останется заполнить данные заведения — без них кабинет не откроется.',
    orgDetailsTitle: 'Данные заведения',
    orgDetailsSubtitle: 'Последний шаг: заполните данные заведения — после этого откроется кабинет.',

    phoneLabel: 'Номер телефона',
    phonePlaceholder: '+7 (___) ___-__-__',
    phoneButton: 'Получить код',
    phoneNotice: 'Код подтверждения придёт в WhatsApp',
    phoneValidationError: 'Номер телефона должен содержать 11 цифр',

    codeLabel: 'Код подтверждения',
    codeSentTo: 'Отправили на',
    codeResend: 'Отправить код повторно',
    codeResendIn: 'Повторная отправка через',
    codeConfirm: 'Подтвердить',
    codeVerifying: 'Проверка...',
    secondsShort: 'сек',

    otherDoorNoCabinet: 'Ещё нет кабинета?',
    otherDoorHasCabinet: 'Уже есть кабинет?',
    otherDoorRegister: 'Зарегистрироваться',
    otherDoorLogin: 'Войти',

    wrongDoorCabinetNotFound: 'С этим номером кабинет не найден. Зарегистрировать заведение?',
    wrongDoorCabinetExists: 'С этим номером кабинет уже заведён. Войти в него?',

    legalNamePlaceholder: 'ТОО «Компания» или ИП «Фамилия»',
    binIin: 'БИН / ИИН',
    city: 'Город',
    citySelect: 'Выберите город',
    legalAddressPlaceholder: 'Город, улица, дом, офис',

    venueSectionTitle: 'Заведение',
    venueSectionHint: 'Это увидят гости: по адресу заведения приложение строит маршрут.',
    venueName: 'Название заведения',
    venueNamePlaceholder: 'Например, Кафе «Уют»',
    venueNameDefaultPlaceholder: 'Кофе Плюс',
    venueAddress: 'Адрес заведения',
    venueAddressPlaceholder: 'г. Алматы, пр. Достык 12',
    mapPickButton: 'Выбрать на карте',
    mapPickHint: 'Кликните по зданию заведения — адрес подставится сам. Точку можно перетащить.',
    mapLookupLoading: 'Определяем адрес по точке…',
    mapAddressHouse: 'Адрес подставлен по точке — проверьте его.',
    mapAddressStreet: 'По точке нашли только улицу — допишите номер дома.',
    mapAddressKeptPre: 'По точке нашли только',
    mapAddressKeptPost: '— оставили адрес, который вы ввели.',
    mapAddressFoundPre: 'По точке нашли',
    mapAddressKeptHousePost: '— оставили номер дома, который вы ввели.',
    mapAddressKeptEarlierPost: '— оставили прежний адрес, проверьте номер дома.',
    mapAddressNone: 'Адрес по точке не определился — впишите его сами.',
    mapPointLabel: 'Точка',
    venueCategory: 'Основная категория',
    venueCategorySelect: 'Выберите категорию',
    venueCategoryOther: 'Другое',

    consentText: 'Я принимаю условия',
    consentLink: 'публичной оферты для партнёров',
    consentRequired: 'Для продолжения необходимо принять оферту',
    offerConsentPre: 'Я принимаю условия',
    offerConsentLink: 'публичной оферты для партнёров',
    offerConsentEdition: 'в редакции от',

    submitRegistration: 'Завершить регистрацию',
    submitting: 'Отправляем...',
    loginSuccess: 'Вход выполнен',
    cabinetCreated: 'Кабинет успешно создан',
    notYourNumber: 'Это не ваш номер?',
    logout: 'Выйти',
    loadingReferences: 'Загружаем…',
    referencesError: 'Не удалось загрузить справочники. Проверьте соединение и обновите страницу.',
    submitFormError: 'Не удалось отправить анкету. Попробуйте ещё раз.',

    validationVenueName: 'Укажите название заведения',
    validationVenueNameShort: 'Название слишком короткое',
    validationCity: 'Выберите город',
    validationVenueAddress: 'Укажите фактический адрес заведения',
    validationVenueAddressShort: 'Адрес заведения слишком короткий',
    validationCategory: 'Выберите основную категорию',
    validationOffer: 'Примите условия оферты',
  },

  nav: {
    home: 'Главная',
    catalog: 'Меню',
    discounts: 'Акции',
    promo: 'Промо',
    qr: 'QR-коды',
    billing: 'Подписка',
    accountMenu: 'Меню аккаунта',
    editProfile: 'Редактировать профиль',
    logout: 'Выйти',
    ariaTopTabs: 'Разделы кабинета',
    ariaBottomNav: 'Нижняя панель навигации',
  },

  cabinet: {
    createDiscount: 'Создать акцию',
    venueProfile: 'ПРОФИЛЬ ЗАВЕДЕНИЯ',
    categoryNote: 'КАТЕГОРИЙ',
    categoryNoteFew: 'КАТЕГОРИИ',
    categoryNoteOne: 'КАТЕГОРИЯ',
    discountNote: 'АКЦИЙ',
    discountNoteFew: 'АКЦИИ',
    discountNoteOne: 'АКЦИЯ',
    storiesAndBanner: 'ИСТОРИИ И БАННЕР',
    subscription: 'ПОДПИСКА',

    subAccessClosed: 'ДОСТУП ЗАКРЫТ',
    subClosesToday: 'ЗАКРОЕТСЯ СЕГОДНЯ',
    subClosesTomorrow: 'ЗАКРОЕТСЯ ЗАВТРА',
    subClosesIn: 'ЗАКРОЕТСЯ ЧЕРЕЗ',
    subOpenBilling: 'Открыть подписку',

    completenessTitle: 'Заполненность заведения',
    completenessHint: 'Чем полнее профиль, тем чаще гости выбирают ваше заведение',
    profileFilled: 'ЗАПОЛНЕНО',
    ariaProfileCompleteness: 'Заполненность карточки заведения',
    whatToImprove: 'Что улучшить →',
    cardFilledPercent: 'Карточка заполнена на',
    fillAction: 'Дозаполнить',
    requiredTag: 'ОБЯЗАТЕЛЬНО',

    trafficTitle: 'Трафик',
    trafficPeriod: 'Период',
    traffic7d: '7 дней',
    traffic30d: '30 дней',
    traffic90d: '90 дней',
    metricPartnerViews: 'Просмотры карточки',
    metricPartnerViewsNote: 'открытия заведения',
    metricCatalogOpens: 'Открытия каталога',
    metricCatalogOpensNote: 'заходы в меню',
    metricDiscountOpens: 'Открытия акций',
    metricDiscountOpensNote: 'из приложения',
    metricContactClicks: 'Контакты',
    metricContactClicksNote: 'звонки, соцсети, маршрут',
    metricQrScans: 'Сканы QR',
    metricQrScansNote: 'таблички со столиков',
    metricNfcTaps: 'NFC-метки',
    metricNfcTapsNote: 'касания метки',
    deltaNoData: 'нет данных за прошлый период',
    deltaToPrev: 'к прошлому периоду',
    sparklineAria: 'Динамика по дням',

    statsViews: 'Просмотры профиля',
    statsMenuViews: 'Просмотры меню',
    statsFavorites: 'В избранном',
    statsActiveDiscounts: 'Активные акции',

    categoriesInCatalog: 'Категорий в каталоге',
    categoriesCountNote: 'разделы витрины',
    activeDiscounts: 'Активных акций',
    activeDiscountsNote: 'видны клиентам сейчас',
    rating: 'Рейтинг',
    ratingNote: 'средняя оценка',
    reviewsCount: 'Отзывов',
    reviewsCountNote: 'всего за время работы',
    allDiscounts: 'Всего акций',
    workNow: 'Работают сейчас',
    workNowNote: 'видны в приложении',
    notWorking: 'Не работают',
    notWorkingNote: 'выключены или вне срока',
    averageDiscount: 'Средняя скидка',

    reviewsTitle: 'Отзывы гостей',
    noReviews: 'Пока нет отзывов',
    reviewReportsTitle: 'Жалобы на отзывы',
    reviewReportsEmpty: 'Жалоб на рассмотрении нет',

    catalogTitle: 'Меню и позиции',
    addCategory: '+ Категория',
    addItem: '+ Позиция',
    createCategoryBtn: 'Создать категорию',
    emptyCatalog: 'В меню пока нет категорий. Создайте первую, чтобы наполнить витрину.',
    emptyCatalogTitle: 'Каталог пуст',
    emptyCatalogDesc: 'Создайте первую категорию — в неё добавляются позиции, а на них уже вешаются скидки.',
    nothingFound: 'Ничего не нашлось по этому запросу',
    noItemsYet: 'В категориях пока нет позиций',
    newCategory: 'Новая категория',
    categoryPlaceholder: 'Например: Напитки, Стрижки, Мойка кузова',
    deleteCategory: 'Удалить категорию',
    firstCreateCategory: 'Сначала создайте категорию',
    price: 'Цена',
    priceWithDiscount: 'Со скидкой',
    item: 'Позиция',
    category: 'Категория',
    discount: 'Скидка',
    noDiscount: 'БЕЗ АКЦИИ',
    shown: 'Показано',
    outOf: 'из',
    positionsCount: 'позиций',

    discountsTitle: 'Акции заведения',
    emptyDiscounts: 'У вас пока нет акций. Создайте первую скидку для привлечения гостей.',
    emptyDiscountsDesc: 'Скидка — это то, ради чего клиент открывает QPrice. Поставьте первую: на категорию целиком или на отдельные позиции, в нужные дни и часы.',
    discountActive: 'Действует сейчас',
    discountSchedule: 'По расписанию',
    discountPercent: 'Скидка',
    discountCol: 'Акция',
    timeCol: 'Время',
    periodCol: 'Срок',
    actionsCol: 'Действия',
    expired: 'Срок истёк',
    openCatalog: 'Открыть каталог',
    days: 'Дни',
    allStates: 'Любое состояние',
    sortByTime: 'По времени начала',
    sortBySize: 'По размеру скидки',
    sortByNew: 'Сначала новые',
    reset: 'Сбросить',
    noDiscountsFiltered: 'Нет акций по выбранным фильтрам',

    promoTitle: 'Продвижение и истории',
    storiesTitle: 'Истории заведения',
    addStory: 'Добавить историю',
    adCampaignsTitle: 'Рекламные кампании',

    qrTitle: 'QR-таблички и NFC-метки',
    qrSubtitle: 'Гости открывают меню без установки приложения',
    qrDownloadPdf: 'Скачать для печати',
    qrTableNumber: 'Столик №',
    qrTargetsMenu: 'Меню',
    qrTargetsMenuHint: 'Табличка на столике: гость сразу видит блюда и цены',
    qrTargetsPartner: 'Карточка заведения',
    qrTargetsPartnerHint: 'Наклейка на входе, на витрине, в чеке',
    qrSourceQr: 'QR-код',
    qrSourceQrHint: 'Печатается на бумаге, работает на любом телефоне',
    qrSourceNfc: 'NFC-метка',
    qrSourceNfcHint: 'Записывается на метку; на части Android NFC выключен — QR всё равно нужен',
    qrModeSingle: 'Один код',
    qrModeBatch: 'По столикам',
    qrTableFrom: 'Столики с',
    qrTableTo: 'по',
    qrShowCodes: 'Показать коды',
    qrPrint: 'Распечатать',
    qrDownload: 'Скачать',
    qrCopyUrl: 'Копировать ссылку',
    qrCopied: 'Скопировано',
    qrCopyImage: 'Копировать картинку',
    qrCopyImageFailed: 'Браузер не дал скопировать картинку — скачайте PNG.',
    qrPageSub: 'Код на столике открывает ваше меню. У кого стоит приложение — в приложении, у остальных — в браузере, с предложением его поставить.',
    qrNotice: 'Сканы считаются отдельно от обычных открытий меню — их видно в аналитике на главной. Если печатаете по столикам, каждый столик считается сам по себе.',
    qrTargetLegend: 'Куда ведёт код',
    qrSourceLegend: 'Носитель',
    qrCountLegend: 'Сколько',
    qrYourCode: 'Ваш код',
    qrCodesCount: 'Коды',
    qrPrintNotice: 'Печатайте не мельче 3 см по стороне и оставляйте белое поле вокруг — иначе камеры перестают наводиться.',
    qrEmpty: 'Коды ещё не построены.',
    qrHowItWorks: 'Как это работает',
    qrHowStep1: 'Гость наводит камеру — открывается меню с вашими ценами и активными скидками.',
    qrHowStep2: 'Если приложение уже стоит, ссылку перехватывает оно и открывает меню внутри.',
    qrHowStep3: 'Если нет — меню открывается в браузере, а поставить приложение предлагается снизу.',
    qrHowStep4: 'Для NFC запишите на метку ту же ссылку — она отсюда. Метка не читается при выключенном NFC, поэтому QR со стола убирать не стоит.',

    billingPageTitle: 'Тарифы и подписка',
    currentTariff: 'Текущий тариф',
    extendAction: 'Продлить подписку',
    noPaymentNeeded: 'Оплата пока не нужна',
    noPaymentNeededDesc: 'Сначала запустите заведение — кнопка на главной. Пробный период начнётся с момента запуска, если он вам положен.',
    toMain: 'На главную',

    legalTitle: 'Реквизиты',
    legalHint: 'Необязательно. Заполните, когда понадобятся договор или закрывающие документы — любые поля, в любой момент.',
    legalPrivacyNote: 'Реквизиты видит только QPrice — гостям приложения они не показываются.',
    legalForm: 'Форма собственности',
    legalFormNone: 'Не выбрана',
    legalName: 'Полное наименование',
    legalNamePlaceholder: 'ТОО «Кофе Плюс»',
    legalNumberHint: '12 цифр из свидетельства о регистрации',
    legalNumberPlaceholder: '12 цифр',
    legalAddress: 'Юридический адрес',
    legalAddressHint: 'Адрес из документов о регистрации, не адрес заведения.',
    legalAddressPlaceholder: 'г. Алматы, ул. Абая 1, оф. 5',
    legalNameShort: 'Наименование слишком короткое',
    legalAddressShort: 'Юридический адрес слишком короткий',
    legalSave: 'Сохранить реквизиты',
    legalSaving: 'Сохраняем…',
    legalSaved: 'Реквизиты сохранены',
    legalSaveError: 'Не удалось сохранить реквизиты. Попробуйте ещё раз.',
    legalEmpty: 'Не заполнены. Это необязательно — понадобятся для договора и закрывающих документов.',
    legalFill: 'Заполнить',
    legalEdit: 'Изменить',
    legalOfferAccepted: 'Оферта принята',
    legalOfferEdition: 'редакция',
  },

  /**
   * Скидки трёх видов (ADR-026): форма, список акций, подписи размера.
   * Подстановки `{…}` заполняет `utils/template.fill`.
   */
  discounts: {
    eyebrow: 'Акции',
    eyebrowCategory: 'раздел целиком',
    eyebrowItems: '{count} поз.',
    eyebrowPieces: '{count} шт.',
    eyebrowNothing: 'не выбрано',
    titleNew: 'Новая скидка',
    titleEdit: 'Редактирование скидки',
    dirty: 'Есть несохранённые изменения',
    clean: 'Всё сохранено',
    cancel: 'Отменить',
    create: 'Создать скидку',
    save: 'Сохранить',
    saving: 'Сохранение…',
    created: 'Скидка создана',
    updated: 'Скидка обновлена',
    saveFailed: 'Не удалось сохранить скидку',
    footNow: 'Скидка включается сразу после сохранения и действует только в выбранное окно.',
    footLater: 'Скидка появится в приложении {date} и будет действовать только в выбранное окно.',

    cardMain: 'Скидка',
    cardMainHint: 'Название видит гость в приложении. От вида зависит, как считается цена.',
    name: 'Название',
    namePlaceholder: 'Например: Чай с пирожным до 18:00',
    nameHint: 'Необязательно. Без названия скидку подпишем тем, на что она действует.',
    kind: 'Вид скидки',
    kindGroup: 'На позиции',
    kindGroupHint: 'Процент или тенге с каждой позиции раздела или списка.',
    kindCombo: 'Комбо',
    kindComboHint: 'Набор позиций за общую цену: чай с пирожным за 1\u00A0500\u00A0₸.',

    cardTarget: 'На что действует',
    cardTargetHint: 'Раздел меню целиком или отдельные позиции.',
    target: 'Цель скидки',
    targetCategory: 'Раздел целиком',
    targetItems: 'Отдельные позиции',
    targetCategoryHint: 'Выберите раздел. Скидка на раздел с подразделами действует и на них.',
    targetItemsHint: 'Раскройте раздел и отметьте позиции.',
    targetPickedCategory: 'Раздел «{name}» целиком · позиций: {count}',
    targetPickedItems: 'Отмечено позиций: {count}',
    errorTargetCategory: 'Выберите раздел',
    errorTargetItems: 'Отметьте хотя бы одну позицию',

    cardValue: 'Размер скидки',
    cardValueHint: 'Снимается с цены каждой позиции: процентом или суммой в тенге.',
    value: 'Размер',
    valueUnit: 'Процент или тенге',
    valuePercentHint: 'От 1 до 100 % от обычной цены.',
    valueAmountHint: 'Целое число тенге с каждой позиции.',
    valueAmountHintMax: 'Не больше {price} — цены самой дешёвой позиции.',
    errorPercent: 'Скидка в процентах — целое число от 1 до 100',
    errorAmount: 'Укажите сумму скидки — целое число тенге, не меньше 1',
    errorAmountTooBig:
      'Скидка {amount} больше цены «{name}» — {price}. Уменьшите скидку или укажите процент.',
    errorAmountNoItems: 'В разделе нет позиций — скидку в тенге не к чему применить. Укажите процент.',
    preview: 'Было → стало',
    previewCheapest: 'Самая дешёвая',
    previewPriciest: 'Самая дорогая',
    previewSingle: 'Позиция',
    previewEmpty: 'Выберите, на что действует скидка, — покажем цены до и после.',

    cardCombo: 'Состав комбо',
    cardComboHint: 'Отметьте позиции и укажите количество. Гость берёт набор целиком.',
    comboEmpty: 'Пока пусто — отметьте позиции в меню ниже.',
    comboPick: 'Позиции меню',
    comboQuantity: 'Количество: {name}',
    comboLess: 'Меньше: {name}',
    comboMore: 'Больше: {name}',
    comboRemove: 'Убрать из комбо: {name}',
    comboUnitPrice: '{price} за шт.',
    comboHidden: 'Не в продаже — пока позиция скрыта, гость комбо не увидит',
    comboRegular: 'Обычная цена набора',
    errorCombo: 'В комбо нужно хотя бы две штуки: две позиции или одна дважды',

    cardBundle: 'Цена комбо',
    cardBundleHint: 'Сколько гость платит за весь набор. Цена должна быть ниже обычной.',
    bundle: 'Цена комбо, ₸',
    bundleHint: 'Целое число тенге за весь набор.',
    bundleRegular: 'Обычная цена',
    bundlePrice: 'Цена комбо',
    bundleSaving: 'Выгода гостя',
    bundleNoSaving: 'нет выгоды',
    errorBundle: 'Укажите цену комбо — целое число тенге',
    errorBundleTooHigh: 'Цена комбо должна быть меньше обычной цены набора — {price}',

    cardWhen: 'Когда действует',
    cardWhenHint: 'Окно внутри суток и дни недели. Дни считаются от начала окна, а не от его конца.',
    timeFrom: 'Время с',
    timeTo: 'Время до',
    timeOvernight: 'Окно переходит через полночь — до {time} следующего дня.',
    errorTime: 'Укажите время начала и окончания',
    errorTimeSame: 'Начало и окончание не могут совпадать',
    days: 'Дни недели',
    daysWeekdays: 'Будни',
    daysWeekend: 'Выходные',
    daysAll: 'Все дни',
    daysClear: 'Очистить',
    errorDays: 'Выберите хотя бы один день недели',
    dayMon: 'Пн',
    dayTue: 'Вт',
    dayWed: 'Ср',
    dayThu: 'Чт',
    dayFri: 'Пт',
    daySat: 'Сб',
    daySun: 'Вс',

    cardPeriod: 'Срок акции',
    cardPeriodHint: 'Календарные даты; окно внутри суток задаётся выше.',
    startsAt: 'Действует с',
    startsAtHint: 'Пусто — акция уже идёт.',
    endsAt: 'Действует по',
    endsAtHint: 'Включительно. Пусто — бессрочно.',
    errorEndsAt: 'Дата окончания не может быть раньше даты начала',

    menuLoading: 'Загружаем меню…',
    menuError: 'Не удалось загрузить меню',
    menuRetry: 'Повторить',
    menuEmpty: 'В меню пока нет разделов. Создайте раздел и добавьте в него позиции.',
    treeBranch: 'раздел с подразделами',
    treeCount: '{count} поз.',
    treeChecked: 'отмечено {count}',
    treeEmpty: 'В этом разделе пока нет позиций',
    treeSelectAll: 'Выбрать все',
    treeUnselectAll: 'Снять все',
    treeExpand: 'Раскрыть раздел',
    treeCollapse: 'Свернуть раздел',

    filterKind: 'Вид акции',
    filterKindAll: 'Все виды',
    filterKindGroup: 'На позиции',
    filterKindCombo: 'Комбо',
    badgeCombo: 'Комбо',
    scopeCategory: 'Раздел «{name}»',
    scopeCategoryUnnamed: 'Раздел',
    scopeNoItems: 'Позиции не выбраны',
    scopeItemOne: 'позиция',
    scopeItemFew: 'позиции',
    scopeItemMany: 'позиций',
    subtitleCategory: 'Скидка на раздел',
    subtitleItems: 'Скидка на позиции',
    subtitleCombo: 'Комбо-набор',
    comboInstead: 'вместо {price}',
    comboNoSaving: 'нет выгоды',
    comboNoSavingTitle:
      'Цена комбо не ниже суммы позиций по текущему меню — гость такое комбо не видит',
    kpiKinds: '{group} на позиции · {combo} комбо',
    kpiAverageNote: 'max −{max} % · только скидки в процентах',
    kpiAverageNone: 'нет скидок в процентах',
  },
};

type DeepStringRecord<T> = {
  readonly [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]>;
};

export type TranslationSchema = DeepStringRecord<typeof ru>;
